module.exports = __webpack_public_path__ + "static/media/SerieLJP.d11a4a54.jpg";